import type { RunRowLike } from "@/types/RunRow"

/** Preserves the filtered order while moving backend-identified outliers first. */
export function promoteOutlierRows(
  rows: RunRowLike[],
  outlierSimulationOutputIds: ReadonlySet<string>,
): RunRowLike[] {
  if (outlierSimulationOutputIds.size === 0) {
    return rows
  }

  const outliers: RunRowLike[] = []
  const remaining: RunRowLike[] = []

  for (const row of rows) {
    if (
      row.simulation_output_id != null &&
      outlierSimulationOutputIds.has(row.simulation_output_id)
    ) {
      outliers.push(row)
    } else {
      remaining.push(row)
    }
  }

  return [...outliers, ...remaining]
}
